// GamesPage.jsx - نسخه فوق‌پیشرفته با انیمیشن‌های نسل جدید
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
import "./GamesPage.css";

const CATEGORIES = [
  { id: "mind", label: "فکری", icon: "🧠", color: "#8b5cf6" },
  { id: "strategy", label: "استراتژی", icon: "♟️", color: "#f59e0b" },
  { id: "sports", label: "ورزشی", icon: "⚽", color: "#34d399" },
  { id: "action", label: "هیجانی", icon: "⚡", color: "#f472b6" },
  { id: "puzzle", label: "معمایی", icon: "🔮", color: "#60a5fa" },
];

const GAMES_BY_CATEGORY = {
  mind: [
    { id: 1, title: "سودوکو", image: "/Games/Game7-1.png", url: "http://hamrahgameland.ir/Games/Sudoku/", players: 234, rating: 4.8 },
    { id: 2, title: "مرتب کردن توپ ها", image: "/Games/Game2-1.png", url: "http://hamrahgameland.ir/Games/MoratabToop/", players: 187, rating: 4.6 },
    { id: 3, title: "هوش برتر", image: "/Games/Game3-1.png", url: "http://hamrahgameland.ir/Games/HoosheBartar/", players: 312, rating: 4.9 },
    { id: 4, title: "۱۰", image: "/Games/Game4-1.png", url: "http://hamrahgameland.ir/Games/10/", players: 156, rating: 4.3 },
    { id: 5, title: "۲۰۴۸", image: "/Games/Game5-1.png", url: "http://hamrahgameland.ir/Games/2048/", players: 423, rating: 4.7 },
    { id: 6, title: "بازی حافظه", image: "/Games/Game6-1.png", url: "http://hamrahgameland.ir/Games/bazihafeze/", players: 198, rating: 4.4 },
  ],
  strategy: [
    { id: 7, title: "توپ خرابکار", image: "/Games/Game1-2.png", url: "http://hamrahgameland.ir/Games/ToopeKharabKar/", players: 267, rating: 4.5 },
    { id: 8, title: "لوله کشی", image: "/Games/Game2-2.png", url: "http://hamrahgameland.ir/Games/LooleKeshi/", players: 145, rating: 4.2 },
    { id: 9, title: "عکس مکث", image: "/Games/Game3-2.png", url: "http://hamrahgameland.ir/Games/AxMax/", players: 198, rating: 4.6 },
    { id: 10, title: "کامیون رنگ", image: "/Games/Game4-2.png", url: "http://hamrahgameland.ir/Games/KamionRang/", players: 234, rating: 4.3 },
    { id: 11, title: "هزارپا", image: "/Games/Game5-2.png", url: "http://hamrahgameland.ir/Games/HezarPa/", players: 167, rating: 4.1 },
  ],
  sports: [
    { id: 12, title: "پنالتی", image: "/Games/Game1-3.png", url: "http://hamrahgameland.ir/Games/penalty-shooter/", players: 567, rating: 4.9 },
    { id: 13, title: "سرخابی", image: "/Games/Game2-3.png", url: "http://hamrahgameland.ir/Games/sorkhabi/", players: 345, rating: 4.7 },
    { id: 14, title: "روپایی", image: "/Games/Game3-3.png", url: "http://hamrahgameland.ir/Games/RoopaiZarebin/", players: 289, rating: 4.4 },
    { id: 15, title: "فوتبال جاذبه", image: "/Games/Game4-3.png", url: "http://hamrahgameland.ir/Games/FootBallJazebe/", players: 412, rating: 4.8 },
  ],
  action: [
    { id: 16, title: "خانه ساز", image: "/Games/Game1-4.png", url: "http://tower.shadnoyan.com/", players: 678, rating: 4.9 },
    { id: 17, title: "توپ آبی", image: "/Games/Game2-4.png", url: "http://hamrahgameland.ir/Games/ToopAbi/", players: 456, rating: 4.6 },
    { id: 18, title: "نجات فضانورد", image: "/Games/Game3-4.png", url: "http://hamrahgameland.ir/Games/FazaNavard/", players: 234, rating: 4.5 },
    { id: 19, title: "مربع پرنده", image: "/Games/Game4-4.png", url: "http://hamrahgameland.ir/Games/MorbaParande/", players: 189, rating: 4.3 },
  ],
  puzzle: [
    { id: 20, title: "توان دودویی", image: "/Games/Game1-1.png", url: "http://hamrahgameland.ir/Games/2For2/", players: 156, rating: 4.2 },
    { id: 21, title: "بیگانگان", image: "/Games/Game8-1.png", url: "http://hamrahgameland.ir/Games/biganegan/", players: 234, rating: 4.5 },
    { id: 22, title: "دوز رنگی", image: "/Games/Game8-2.png", url: "http://hamrahgameland.ir/Games/DoozeRangi/", players: 178, rating: 4.0 },
    { id: 23, title: "حلقه طلایی", image: "/Games/Game6-4.png", url: "http://hamrahgameland.ir/Games/Halghe/", players: 145, rating: 4.1 },
  ],
};

// ====== کامپوننت ستاره‌های درخشان ======
const StarField = () => {
  const stars = useRef([]);
  const [starData, setStarData] = useState([]);

  useEffect(() => {
    const data = [];
    for (let i = 0; i < 80; i++) {
      data.push({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 3 + 1,
        speed: Math.random() * 2 + 1,
        delay: Math.random() * 5,
        opacity: Math.random() * 0.5 + 0.5,
      });
    }
    setStarData(data);
  }, []);

  return (
    <div className="star-field">
      {starData.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            animationDuration: `${star.speed}s`,
            animationDelay: `${star.delay}s`,
            opacity: star.opacity,
          }}
        />
      ))}
    </div>
  );
};

// ====== کامپوننت ذرات در حال چرخش ======
const ParticleRing = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const data = [];
    for (let i = 0; i < 40; i++) {
      const angle = (i / 40) * Math.PI * 2;
      const radius = 120 + Math.random() * 80;
      data.push({
        id: i,
        angle,
        radius,
        size: Math.random() * 4 + 2,
        color: `hsl(${260 + Math.random() * 40}, 80%, 60%)`,
        speed: 0.5 + Math.random() * 0.5,
        delay: Math.random() * 2,
      });
    }
    setParticles(data);
  }, []);

  return (
    <div className="particle-ring-container">
      {particles.map((p) => (
        <div
          key={p.id}
          className="particle-ring"
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.color,
            boxShadow: `0 0 ${p.size * 2}px ${p.color}`,
            animationDuration: `${8 / p.speed}s`,
            animationDelay: `${p.delay}s`,
            transform: `rotate(${p.angle}rad) translateX(${p.radius}px)`,
          }}
        />
      ))}
    </div>
  );
};

export default function GamesPage() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState("mind");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hoveredGame, setHoveredGame] = useState(null);
  const [clickedGame, setClickedGame] = useState(null);
  const [floatingEmojis, setFloatingEmojis] = useState([]);
  const [confetti, setConfetti] = useState([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHeroHovered, setIsHeroHovered] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedGame, setSelectedGame] = useState(null);
  const [gameStats, setGameStats] = useState({ total: 0, played: 0, achievements: 0 });
  const heroRef = useRef(null);

  const gamesToShow = GAMES_BY_CATEGORY[activeCategory] || [];
  const filteredGames = gamesToShow.filter(g =>
    g.title.includes(searchTerm) || searchTerm === ""
  );
  const displayGames = filteredGames.slice(0, 6);

  // ====== ایموجی‌های شناور سه‌بعدی ======
  useEffect(() => {
    const emojis = ["🎮", "⭐", "🚀", "✨", "🎯", "🏆", "🪙", "🎪", "🌈", "🔥", "💎", "🎲"];
    const data = [];
    for (let i = 0; i < 20; i++) {
      data.push({
        id: i,
        emoji: emojis[i % emojis.length],
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 30 + 20,
        speed: Math.random() * 15 + 10,
        delay: Math.random() * 10,
        floatX: (Math.random() - 0.5) * 30,
        floatY: (Math.random() - 0.5) * 30,
        rotate: Math.random() * 360,
      });
    }
    setFloatingEmojis(data);
  }, []);

  // ====== انیمیشن موس ======
  useEffect(() => {
    const handleMouseMove = (e) => {
      const rect = document.querySelector('.games-page')?.getBoundingClientRect();
      if (rect) {
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        setMousePosition({ x, y });
      }
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // ====== کنفتی هوشمند ======
  const triggerConfetti = useCallback((count = 60) => {
    const colors = ["#fbbe24"];
    const newConfetti = [];
    for (let i = 0; i < count; i++) {
      const angle = Math.random() * Math.PI * 2;
      const velocity = 200 + Math.random() * 400;
      newConfetti.push({
        id: i,
        color: colors[Math.floor(Math.random() * colors.length)],
        x: 50 + (Math.random() - 0.5) * 20,
        y: 50 + (Math.random() - 0.5) * 20,
        vx: Math.cos(angle) * velocity * (0.5 + Math.random() * 0.5),
        vy: Math.sin(angle) * velocity * (0.5 + Math.random() * 0.5) - 100,
        size: Math.random() * 12 + 6,
        rotation: Math.random() * 720,
        duration: 2 + Math.random() * 2,
        delay: Math.random() * 0.3,
        gravity: 300 + Math.random() * 200,
        opacity: 1,
      });
    }
    setConfetti(newConfetti);
    setTimeout(() => setConfetti([]), 3500);
  }, []);

  // ====== کلیک روی بازی ======
  const handleGameClick = useCallback((game) => {
    setClickedGame(game.id);
    triggerConfetti(80);
    setSelectedGame(game);
    setGameStats(prev => ({
      ...prev,
      played: prev.played + 1,
      total: prev.total + 1,
    }));
    setTimeout(() => setClickedGame(null), 500);
    if (game.url) {
      setTimeout(() => {
        window.location.href = game.url;
      }, 600);
    }
  }, [triggerConfetti]);

  // ====== تغییر دسته‌بندی ======
  const handleCategorySelect = useCallback((cat) => {
    if (cat !== activeCategory) {
      setActiveCategory(cat);
      triggerConfetti(40);
      setIsModalOpen(false);
    }
  }, [activeCategory, triggerConfetti]);

  // ====== دریافت آمار ======
  useEffect(() => {
    const total = Object.values(GAMES_BY_CATEGORY).reduce((acc, arr) => acc + arr.length, 0);
    setGameStats(prev => ({ ...prev, total }));
  }, []);

  // ====== رندر ستاره‌های امتیاز ======
  const renderStars = (rating) => {
    const full = Math.floor(rating);
    const half = rating - full >= 0.5;
    const stars = [];
    for (let i = 0; i < 5; i++) {
      if (i < full) stars.push('⭐');
      else if (i === full && half) stars.push('🌟');
      else stars.push('☆');
    }
    return stars.join(' ');
  };

  return (
    <div className="games-page" style={{ '--mouse-x': mousePosition.x + '%', '--mouse-y': mousePosition.y + '%' }}>
      {/* ====== پس‌زمینه ستاره‌ای ====== */}
      <StarField />

      {/* ====== حلقه ذرات چرخان ====== */}
      <ParticleRing />

      {/* ====== ایموجی‌های شناور ۳D ====== */}
      <div className="floating-emojis-3d">
        {floatingEmojis.map((item) => (
          <span
            key={item.id}
            className="floating-emoji-3d"
            style={{
              left: `${item.x}%`,
              top: `${item.y}%`,
              fontSize: `${item.size}px`,
              animationDuration: `${item.speed}s`,
              animationDelay: `${item.delay}s`,
              '--float-x': `${item.floatX}px`,
              '--float-y': `${item.floatY}px`,
              '--rotate': `${item.rotate}deg`,
            }}
          >
            {item.emoji}
          </span>
        ))}
      </div>

      {/* ====== کنفتی ====== */}
      {confetti.map((item) => (
        <div
          key={item.id}
          className="confetti-advanced"
          style={{
            left: `${item.x}%`,
            top: `${item.y}%`,
            backgroundColor: item.color,
            width: `${item.size}px`,
            height: `${item.size * 0.5}px`,
            animationDuration: `${item.duration}s`,
            animationDelay: `${item.delay}s`,
            '--vx': `${item.vx}px`,
            '--vy': `${item.vy}px`,
            '--rotation': `${item.rotation}deg`,
            '--gravity': `${item.gravity}px`,
          }}
        />
      ))}

      {/* ====== هدر با انیمیشن پارالاکس ====== */}
      <header className="hero-header">
        <div className="hero-header-bg" ref={heroRef}>
          <div className="hero-gradient-orbs">
            <div className="orb orb-1"></div>
            <div className="orb orb-2"></div>
            <div className="orb orb-3"></div>
            <div className="orb orb-4"></div>
          </div>
        </div>

        <div className="hero-header-content">
          <div className="hero-top">
            <button className="back-btn" onClick={() => navigate('/home')}>
            <i className="fas fa-arrow-left"></i> بازگشت
          </button>
            <div className="hero-search1">
              

          <span className="live-badge">
              <span className="live-dot"></span>
              LIVE
            </span>
            </div>
          </div>

          <h1 className="hero-glow-title">
            <span className="title-part">🎮</span>
            <span className="title-part gradient-text">ماجراجویی</span>
            <span className="title-part">بازیهای</span>
            <span className="title-3d">جدید</span>
          </h1>

          <p className="hero-description">
            وارد دنیای بی‌نهایت بازی‌های هیجان‌انگیز شو
            <span className="typing-cursor">|</span>
          </p>

          <div className="hero-actions">
            <button className="hero-primary-btn" onClick={() => setIsModalOpen(true)}>
              <span className="btn-ripple"></span>
              <span className="btn-content">🚀 کشف بازی‌ها</span>
            </button>
            <div className="hero-stats">
              <div className="hero-stat">
                <span className="stat-number">{gameStats.total}</span>
                <span className="stat-label">بازی‌</span>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <span className="stat-number">{gameStats.played}</span>
                <span className="stat-label">بازی‌شده</span>
              </div>
              <div className="hero-stat-divider"></div>
              <div className="hero-stat">
                <span className="stat-number">🏆</span>
                <span className="stat-label">رتبه</span>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* ====== دسته‌بندی‌های پیشرفته ====== */}
      <div className="categories-advanced">
        {CATEGORIES.map((cat, index) => (
          <button
            key={cat.id}
            className={`category-pill ${activeCategory === cat.id ? 'active' : ''}`}
            style={{
              animationDelay: `${index * 0.08}s`,
              '--cat-color': cat.color,
            }}
            onClick={() => handleCategorySelect(cat.id)}
          >
            <span className="cat-icon">{cat.icon}</span>
            <span className="cat-label">{cat.label}</span>
            <span className="cat-count">{GAMES_BY_CATEGORY[cat.id].length}</span>
            {activeCategory === cat.id && <span className="cat-active-ring"></span>}
          </button>
        ))}
      </div>

      {/* ====== شبکه بازی‌های پیشرفته ====== */}
      <section className="games-advanced">
        <div className="games-header-advanced">
          <div className="games-title-group">
            <h2 className="games-section-title">
              <span className="title-emoji">🎯</span>
              {CATEGORIES.find(c => c.id === activeCategory)?.label || ''}
              <span className="title-shine">✦</span>
            </h2>
            <span className="games-subtitle">
              {displayGames.length} بازی آماده
            </span>
          </div>
          <button className="view-all-btn" onClick={() => setIsModalOpen(true)}>
            مشاهده همه
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path d="M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
              <path d="M4 12h16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="games-grid-advanced">
          {displayGames.length > 0 ? (
            displayGames.map((game, index) => (
              <div
                key={game.id}
                className={`game-card-advanced ${hoveredGame === game.id ? 'hovered' : ''} ${clickedGame === game.id ? 'clicked' : ''}`}
                style={{ animationDelay: `${index * 0.08}s` }}
                onClick={() => handleGameClick(game)}
                onMouseEnter={() => setHoveredGame(game.id)}
                onMouseLeave={() => setHoveredGame(null)}
              >
                <div className="card-glow-border"></div>
                <div className="card-image-container">
                  <div
                    className="card-game-image"
                    style={{
                      backgroundImage: game.image ? `url(${game.image})` : "none",
                      backgroundColor: "#1a1a3e",
                    }}
                  />
                  <div className="card-hover-overlay">
                    <div className="play-button-circle">
                      <span className="play-triangle">▶</span>
                    </div>
                    <span className="play-label">بازی کن</span>
                  </div>
                  <div className="card-badges">
                    <span className="card-badge rating">{game.rating}⭐</span>
                    <span className="card-badge players">👥 {game.players}</span>
                  </div>
                </div>
                <div className="card-info-advanced">
                  <h4 className="card-title-advanced">{game.title}</h4>
                  <div className="card-meta-advanced">
                    <span className="card-category-tag">
                      {CATEGORIES.find(c => c.id === activeCategory)?.icon}
                      {CATEGORIES.find(c => c.id === activeCategory)?.label}
                    </span>
                    <span className="card-engagement">
                      <span className="engagement-dot"></span>
                      30 فعال
                    </span>
                  </div>
                </div>
                <div className="card-ripple-effect"></div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <span className="empty-emoji">🔍</span>
              <p className="empty-text">بازی‌ای با این نام پیدا نشد</p>
            </div>
          )}
        </div>
      </section>

      {/* ====== بخش پایانی با انیمیشن ====== */}
      <footer className="games-footer">
        <div className="footer-content">
          <div className="footer-live">
            <span className="live-indicator">
              <span className="live-pulse"></span>
              آنلاین
            </span>
            <span className="footer-players">
              🎮 300 بازیکن
            </span>
          </div>
          <div className="footer-social">
            <span className="social-icon">🎵</span>
            <span className="social-icon">📺</span>
            <span className="social-icon">💬</span>
          </div>
        </div>
        <div className="footer-progress">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${(gameStats.played / Math.max(gameStats.total, 1)) * 100}%` }}></div>
          </div>
          <span className="progress-text">{gameStats.played} بازی از {gameStats.total}</span>
        </div>
      </footer>

      {/* ====== مودال پیشرفته ====== */}
      {isModalOpen && (
        <div className="modal-advanced" onClick={() => setIsModalOpen(false)}>
          <div className="modal-advanced-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-advanced" onClick={() => setIsModalOpen(false)}>
              <span className="close-icon">✕</span>
            </button>
            <h3 className="modal-title">📂 دسته‌بندی بازی‌ها</h3>
            <div className="modal-grid">
              {CATEGORIES.map((cat) => (
                <button
                  key={cat.id}
                  className={`modal-category-item ${activeCategory === cat.id ? 'active' : ''}`}
                  onClick={() => handleCategorySelect(cat.id)}
                  style={{ '--cat-color': cat.color }}
                >
                  <span className="modal-cat-icon">{cat.icon}</span>
                  <div className="modal-cat-info">
                    <span className="modal-cat-label">{cat.label}</span>
                    <span className="modal-cat-count">{GAMES_BY_CATEGORY[cat.id].length} بازی</span>
                  </div>
                  {activeCategory === cat.id && <span className="modal-cat-check">✅</span>}
                </button>
              ))}
            </div>
            <p className="modal-tip-advanced">💡 برای شروع، یک دسته‌بندی انتخاب کن!</p>
          </div>
        </div>
      )}
    </div>
  );
}